<template>
  <!-- 左侧飘窗 -->
  <div class="chuang" v-if="left_img">
    <a href="http://zhubaobgcx.ccaa.org.cn/" target="_blank"><img src="~@/assets/images/home/href.jpg" alt="" /></a>
    <img class="close" @click="close" src="~@/assets/images/home/close.gif" alt="" />
  </div>
</template>

<script>
export default {
  name: 'left',
  data () {
    return {
      left_img: true
    }
  },
  created () {
  },
  mounted () {


  },
  methods: {
    close () {
      this.left_img = false
    }
  },
}
</script>
<style lang="scss" scoped>
.chuang {
  width: 115px;
  position: fixed;
  left: 0;
  top: 50%;
  margin-top: -210px;
  z-index: 9999;

  a {
    width: 115px;
    display: block;

    img {
      width: 100%;
    }
  }

  .close {
    width: 27px;
    margin: 10px auto 0 auto;
    display: block;
    cursor: pointer;
  }
}
</style>